import { gql } from '@apollo/client';
import defaultPageData from '@/lib/wp/_partials/defaultPageData';
import seoPostFields from '@/lib/wp/_partials/seoPostFields';
import { archivePostsFragment } from '@/lib/wp/archives/queryArchives';

const queryPostArchive = gql`
  query GET_ARCHIVE_POSTS(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $orderBy: PostObjectsConnectionOrderbyEnum = DATE
    $order: OrderEnum = DESC
    $imageSize: MediaItemSizeEnum = THUMBNAIL
  ) {
    ${defaultPageData}
    homepageSettings {
      postsPage {
        ${seoPostFields}
      }
    }
    posts(
      first: $first
      last: $last
      after: $after
      before: $before
      where: { orderby: { field: $orderBy, order: $order }}
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          ...ArchivePostFields
        }
      }
    }
  }
  ${archivePostsFragment}
`;

export default queryPostArchive;
